import {db} from "./firebase";
import {doc, setDoc} from "firebase/firestore"; 

const apiKey = process.env.REACT_APP_GMAP_KEY; 

//Note this API is insecure - should use this API as part of @dans back end code
// Will disable API key once live
export const getLatLongFromAddress = async (postcode) => {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${postcode}&key=${apiKey}`;
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error('Failed to fetch data from Google Maps API');
    }
    const data = await response.json();
    return data
}

//Internal API to get the slurry emissions
export const getSlurryEmissions = async (request) => {

    //TODO error handling
    const geocode = await getLatLongFromAddress(request.postcode)
    const lat = geocode.results[0].geometry.location.lat;
    const long = geocode.results[0].geometry.location.lng;
    request.lat = lat;
    request.long = long;
    console.log("Request", request)

    return fetch("https://slurry-emissions-zvuc64goyq-uc.a.run.app", {
        method: "POST", 
        body: JSON.stringify(request), 
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }})
}

// Firestore stuff
export const writeEmailToFirebase = async (email, details) => {
    const docRef = doc(db, "mailing_list", email);
    //TODO check if email already exists - should do some logic here?
    try {
        console.log("Writing email to firebase", email, details)
        await setDoc(docRef, { ...details}); 
    } catch (error) {
        console.error("Error writing user name:", error);
    }
}
